import { LoginType, MsalAuthProvider } from 'react-aad-msal';

import { getEnvironmentVar } from '../../utils';

declare global {
  interface Window {
    _env_: any;
  }
}

export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: getEnvironmentVar('AZURE_APP_AUTHORITY'),
      clientId: getEnvironmentVar('AZURE_APPLICATION_CLIENT_ID') || '',
      navigateToLoginRequestUrl: true,
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  },
  {
    prompt: 'consent',
    scopes: [`${getEnvironmentVar('AZURE_APPLICATION_ID_URI')}/user_impersonation` || ''],
  },
  LoginType.Redirect,
);
